export default __webpack_public_path__ + "static/media/p1.c4220b17.png";